var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mt-1 mb-1",staticStyle:{"height":"28px"}},[(_vm.isSending)?_c('span',[_c('strong',[_vm._v("J.L. AI")]),_vm._v(" est en train d'écrire... ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }